import { render, staticRenderFns } from "./CreateContactList.vue?vue&type=template&id=596ec82a&scoped=true&"
import script from "./CreateContactList.vue?vue&type=script&lang=js&"
export * from "./CreateContactList.vue?vue&type=script&lang=js&"
import style0 from "./CreateContactList.vue?vue&type=style&index=0&id=596ec82a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596ec82a",
  null
  
)

export default component.exports